import { jsx } from "react/jsx-runtime";
import { useMemo, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { DiseaseType } from "../../../../../type/Disease.js";
import { Formik, Form, Field } from "formik";
import { DiseaseGroupField } from "../../components/disease-group-field/disease-group-field.js";
import { FormLayout } from "../../components/form-layout/form-layout.js";
import { SubmitButton } from "../../components/submit-button/submit-button.js";
import { Translate } from "../../components/translate/translate.js";
import { diseasesByType, diseasesForPage1, diseasesForPage2, diseasesForPage3 } from "../../utils/config/diseases.js";
import { usePreConditionsLogic } from "../../utils/hooks/usePreConditionsToggle.js";
import { HelperText } from "./preconditions.styles.js";
import "@mui/material";
import "../../utils/helpers/DiseaseType.js";
import "../../utils/shared/RadioFormLabel.js";
import "../../components/disease-field/disease-field.js";
import "@mui/icons-material/Close.js";
import "../../utils/shared/TextField.js";
import "../../components/tag/tag.js";
import "../../components/tag/tag.styles.js";
import "@mui/icons-material/Cancel.js";
import "../../components/disease-field/disease-field.styles.js";
import "@mui/styles";
import "../../components/field-helper-text/field-helper-text.js";
import "../../utils/yup/main.js";
import "yup";
import "../../utils/fields/personalInformation.js";
import "../../../../../type/Appointment.js";
import "../../components/masked-date-input/masked-date-input.js";
import "react-text-mask";
import "../../utils/entities/Form.js";
import "../../../ana-toolbox/ana-toolbox.js";
import "../../../../../constants/date/date.js";
import "date-fns/fp/format";
import "date-fns/isValid";
import "date-fns/parse";
import "date-fns";
import "../../utils/helpers/toBoolean.js";
import "../../utils/helpers/createFields.js";
import "../../utils/helpers/resetFields.js";
import "../../utils/yup/yup.js";
import "../../../../../utils/pipe.js";
import "date-fns/fp";
import "libphonenumber-js/max";
import "libphonenumber-js/mobile";
import "../../utils/helpers/predicates.js";
import "../../utils/yup/emailValidation.js";
import "../../utils/fields/contactDetails.js";
import "../../utils/helpers/featureFlags.js";
import "../../utils/helpers/getAgeFromBirthday.js";
import "../../utils/yup/buildValidationSchema.js";
import "../../utils/fields/miscellaneous.js";
import "../../utils/fields/insurance.js";
import "../../utils/fields/allergiesAndMedications.js";
import "../../utils/config/medicaments.js";
import "../../utils/fields/wishesAndExpectations.js";
import "../../utils/fields/consents.js";
import "../../utils/fields/profileInterest.js";
import "../../components/disease-group-field/disease-group-field.helpers.js";
import "../../components/disease-group-field/disease-group-field.styles.js";
import "react-dom";
import "lodash";
import "../../utils/helpers/createField.js";
import "../../components/address-field/address-field.js";
import "../../utils/helpers/getHasError.js";
import "../../utils/hooks/useAddressSuggestions.js";
import "use-debounce";
import "../../utils/helpers/googlePlaces.js";
import "../../utils/helpers/places.js";
import "../../utils/hooks/useFormHelpers.js";
import "../../utils/hooks/useSubmitCount.js";
import "../../utils/shared/TextFieldLabel.js";
import "../../components/checkbox-field/checkbox-field.js";
import "../../utils/shared/Checkbox.js";
import "../../components/checkbox-field/checkbox-field.styles.js";
import "../../utils/shared/FormControlLabel.js";
import "../../components/date-picker-field/date-picker-field.js";
import "@mui/x-date-pickers/StaticDatePicker/index.js";
import "date-fns/fp/formatWithOptions";
import "date-fns/locale/de";
import "date-fns/locale/en-US";
import "../../utils/helpers/date.js";
import "date-fns/fp/startOfMonth";
import "date-fns/fp/subYears";
import "../../components/date-picker-field/date-picker-field.styles.js";
import "@mui/x-date-pickers";
import "../../components/phone-field/phone-field.js";
import "react-window";
import "@mui/icons-material/ArrowDropDown.js";
import "libphonenumber-js";
import "../../utils/helpers/phoneMetadata.js";
import "../../components/text-input/text-input.js";
import "../../components/text-input/text-input.styles.js";
import "../../components/phone-field/phone-field.styles.js";
import "@emotion/react";
import "../../components/radio-group/radio-group.js";
import "use-deep-compare";
import "../../utils/shared/Radio.js";
import "../../utils/shared/RadioFormControl.js";
import "../../utils/shared/RadioFormControlLabel.js";
import "../../utils/shared/RadioGroup.js";
import "../../components/select-field/select-field.js";
import "../../components/select-input/select-input.js";
import "../../components/select-input/select-input.styles.js";
import "../../components/text-field/text-field.js";
import "../../components/toggle-field/toggle-field.js";
import "../../utils/shared/ToggleContainer.js";
import "../../utils/shared/ToggleFormControlLabel.js";
import "../../utils/helpers/getIsRequired.js";
import "../../utils/hooks/useFormValue.js";
import "../../components/form-layout/form-layout.styles.js";
import "../../../../../components/loader/loader.js";
import "../../../../../components/loader/data.js";
import "../../../../../components/animation/animation.js";
import "lottie-react";
import "../../../../../components/loader/loader.styles.js";
import "../../utils/shared/Button.js";
import "../../components/submit-button/submit-button.styles.js";
import "@mui/system";
import "../../utils/helpers/scrollToElementIfNotVisible.js";
import "../../utils/helpers/isInViewport.js";
const groupDiseaseByType = (diseases) => diseases.reduce((grouped, disease) => {
  const previousDiseasesForCurrentType = grouped[disease.type] || [];
  return {
    ...grouped,
    [disease.type]: [...previousDiseasesForCurrentType, disease]
  };
}, {});
const helperTexts = {
  [DiseaseType.SURGERY]: {
    helperText: "which_surgeries_subtitle",
    activeHelperText: "field.which_surgeries_subtitle",
    placeholder: "field.did_you_ever_have_surgery_placeholder"
  },
  [DiseaseType.OTHER]: {
    helperText: "which_other_disease_subtitle",
    activeHelperText: "field.which_other_disease_subtitle",
    placeholder: "field.other_disease_placeholder"
  }
};
const PreConditionsForm = ({
  initialValues = {},
  diseases,
  diseaseGroupLabelByIndex = {},
  showSurgery,
  onSubmit,
  loading,
  innerRef,
  portalAttr,
  logic
}) => {
  const preconditionsLogic = usePreConditionsLogic({
    initialValues,
    diseases
  });
  const {
    errors,
    hasError,
    collapseStates,
    selectedDiseases,
    handleToggleChange,
    handleDiseaseCheck,
    handleDiseaseChange,
    ...preConditionsLogic
  } = logic || preconditionsLogic;
  const handleSubmit = (values) => {
    preConditionsLogic.handleSubmit();
    onSubmit({
      ...values,
      diseases: selectedDiseases
    });
  };
  const { t } = useTranslation();
  const diseasesGroupedEntries = useMemo(() => {
    const diseasesGroupedByType = groupDiseaseByType(diseases);
    return Object.entries(diseasesGroupedByType);
  }, [diseases]);
  const renderDiseaseGroup = useCallback(
    ([groupType, groupDiseases], index) => {
      var _a, _b;
      const diseaseType = groupType;
      const label = diseaseGroupLabelByIndex[index];
      const originalError = errors[diseaseType];
      const errorPresent = Boolean(originalError);
      const error = groupType === DiseaseType.SURGERY && errorPresent ? "surgery_required" : originalError;
      return /* @__PURE__ */ jsx(
        DiseaseGroupField,
        {
          type: diseaseType,
          label: label && `disease_prefix_${label}`,
          diseases: diseasesByType[diseaseType],
          selectedDiseases,
          allDiseases: groupDiseases,
          error,
          checked: Boolean(collapseStates[diseaseType]),
          onToggle: handleToggleChange,
          onDiseaseCheck: handleDiseaseCheck,
          onDiseaseChange: handleDiseaseChange,
          hideMedications: diseaseType === DiseaseType.SURGERY,
          activeHelperText: (_a = helperTexts[diseaseType]) == null ? void 0 : _a.activeHelperText,
          customInputPlaceholder: (_b = helperTexts[diseaseType]) == null ? void 0 : _b.placeholder
        },
        diseaseType
      );
    },
    [
      diseaseGroupLabelByIndex,
      collapseStates,
      handleDiseaseChange,
      handleDiseaseCheck,
      handleToggleChange,
      errors,
      selectedDiseases
    ]
  );
  const layout = useMemo(() => {
    const diseaseItems = diseasesGroupedEntries.map(([groupType, groupDiseases], index) => ({
      type: "custom",
      key: groupType,
      xs: 12,
      render: () => renderDiseaseGroup([groupType, groupDiseases], showSurgery ? index + 1 : index)
    }));
    const surgeryItems = showSurgery ? [
      {
        type: "custom",
        key: DiseaseType.SURGERY,
        xs: 12,
        render: () => renderDiseaseGroup([DiseaseType.SURGERY, diseasesByType[DiseaseType.SURGERY]], 0)
      }
    ] : [];
    return [
      {
        type: "custom",
        key: "helper",
        xs: 12,
        align: "center",
        render: () => /* @__PURE__ */ jsx(HelperText, { children: /* @__PURE__ */ jsx(Translate, { children: "pre_existing_conditions_helper_text" }) })
      },
      ...surgeryItems,
      ...diseaseItems
    ];
  }, [showSurgery, renderDiseaseGroup, diseasesGroupedEntries]);
  const submitButton = /* @__PURE__ */ jsx(Field, { children: (props) => {
    return /* @__PURE__ */ jsx(
      SubmitButton,
      {
        loading,
        onClick: () => props.form.submitForm(),
        disabled: !props.form.isValid || hasError,
        children: t("next")
      }
    );
  } });
  return /* @__PURE__ */ jsx(Formik, { innerRef, initialValues, onSubmit: handleSubmit, children: /* @__PURE__ */ jsx(Form, { children: /* @__PURE__ */ jsx(FormLayout, { portalAttr, items: layout, submitButton }) }) });
};
const PreConditionsForm1 = (props) => /* @__PURE__ */ jsx(
  PreConditionsForm,
  {
    ...props,
    diseaseGroupLabelByIndex: {
      0: "had",
      1: "have"
    },
    showSurgery: true,
    diseases: diseasesForPage1
  }
);
const PreConditionsForm2 = (props) => /* @__PURE__ */ jsx(
  PreConditionsForm,
  {
    ...props,
    diseaseGroupLabelByIndex: {
      0: "have"
    },
    diseases: diseasesForPage2
  }
);
const PreConditionsForm3 = (props) => /* @__PURE__ */ jsx(PreConditionsForm, { ...props, diseaseGroupLabelByIndex: { 0: "have" }, diseases: diseasesForPage3 });
export {
  PreConditionsForm,
  PreConditionsForm1,
  PreConditionsForm2,
  PreConditionsForm3
};
